import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty, isNil } from 'ramda';
import styles from './NavigationBlock.module.css';

export const NavigationBlock = ({
  title,
  collection,
  renderItem,
  className,
  ...props
}) => (
  <div className={classNames(styles.component, className)} {...props}>
    {title}

    {!isNil(collection) && !isEmpty(collection) && (
      <ul className={styles.list}>
        {collection.map((item, index) => (
          <li key={item.id} className={styles.item}>
            {renderItem(item, index)}
          </li>
        ))}
      </ul>
    )}
  </div>
);

NavigationBlock.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.string,
  ]),
  collection: PropTypes.array,
  renderItem: PropTypes.func,
};

NavigationBlock.defaultProps = {
  title: '',
  collection: [],
  renderItem: () => null,
};

export default NavigationBlock;
